module.exports = __webpack_public_path__ + "static/img/p5.5250429.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/p5.jpg
// module id = 66
// module chunks = 1